export class SetSync {
  static readonly type = '[Questions API] Set Questions Syncing Status';
  constructor(public payload: boolean) {}
}

export class GetQuestions {
  static readonly type = '[Questions API] Get Questions';
}
